export interface Article {
  id: string;
  title: string;
  slug: string;
  categoryId: string;
  categoryName: string;
  excerpt: string;
  content: string;
  imageUrl: string;
  date: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: '1',
    title: '吉泽明步个人档案：从出生到成名的完整人生轨迹',
    slug: 'yoshizawa-akihō-personal-profile',
    categoryId: 'personal',
    categoryName: '个人资料',
    excerpt: '吉泽明步（Akiho Yoshizawa），出生于日本东京都，是一位在日本影视界具有广泛影响力的艺人。本文将为你详细梳理她的个人基本信息、成长背景以及进入行业的契机。',
    content: `<p>吉泽明步（Akiho Yoshizawa），出生于日本东京都，是一位在日本影视界具有广泛影响力的艺人。她以其出色的表演天赋和独特的个人魅力，在行业内赢得了极高的声誉和大量忠实粉丝。</p>
    <h2>基本信息</h2>
    <p>吉泽明步于1984年3月3日出生于日本东京都。她的本名在业内广为人知，但她也曾使用过不同的艺名进行活动。身高161cm的她在镜头前展现出极佳的比例和表现力，三围数据为B86-W58-H86（cm），属于标准的模特身材。</p>
    <h2>成长背景</h2>
    <p>吉泽明步在东京长大，从小就对表演艺术展现出浓厚的兴趣。在学生时代，她积极参与各种文艺活动，培养了良好的舞台感和镜头感。她的家庭背景相对普通，但父母一直支持她追求自己的梦想。</p>
    <h2>入行契机</h2>
    <p>2003年，年仅19岁的吉泽明步被星探发掘，正式踏入演艺圈。当时她正在东京涉谷街头，因其出众的外貌和气质被业内人士相中。经过深思熟虑后，她决定接受挑战，开启了自己的演艺生涯。</p>
    <h2>兴趣爱好</h2>
    <p>在工作之余，吉泽明步热爱旅行和美食。她曾在多个访谈中表示，旅行能够让她放松心情、开阔视野。此外，她对时尚也有着独到的见解，经常在社交媒体上分享自己的日常穿搭。</p>
    <h2>社会活动</h2>
    <p>除了演艺工作，吉泽明步也积极参与各类社会公益活动。她曾多次参与慈善募捐和社区服务，用实际行动回馈社会，展现了作为公众人物的社会责任感。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20entertainment%20portrait%20photography%20with%20soft%20warm%20lighting%20and%20minimalist%20cream%20background%2C%20artistic%20composition%2C%20professional%20studio%20setup%20with%20subtle%20shadows%2C%20editorial%20style%2C%20refined%20and%20sophisticated%20atmosphere&width=1200&height=675&seq=yoshizawa-profile-01&orientation=landscape',
    date: '2026-07-15',
    readTime: '8 分钟',
    tags: ['个人资料', '吉泽明步', '档案', '基本信息'],
    featured: true,
  },
  {
    id: '2',
    title: '吉泽明步演艺生涯全回顾：从新人到传奇的蜕变之路',
    slug: 'yoshizawa-akihō-career-review',
    categoryId: 'career',
    categoryName: '演艺经历',
    excerpt: '从2003年初入行到成为行业标志性人物，吉泽明步用二十余年的职业生涯书写了一段传奇。本文带你回顾她演艺道路上的每一个重要时刻。',
    content: `<p>从2003年初入行到成为行业标志性人物，吉泽明步用二十余年的职业生涯书写了一段令人瞩目的传奇故事。</p>
    <h2>出道初期（2003-2005）</h2>
    <p>2003年，吉泽明步以新人身份正式出道。她的第一部作品就获得了业内人士的广泛关注。凭借清纯的外形和自然的表演风格，她迅速在竞争激烈的市场中站稳了脚跟。出道第一年，她就获得了多项新人奖项的提名。</p>
    <h2>快速上升期（2006-2009）</h2>
    <p>2006年开始，吉泽明步进入了事业的快速上升期。这一时期，她尝试了多种不同类型的角色，演技得到了显著提升。2008年，她凭借在一部重量级作品中的出色表现，获得了当年度的最佳女演员奖项，这标志着她正式跻身顶级艺人的行列。</p>
    <h2>巅峰时期（2010-2015）</h2>
    <p>进入2010年代，吉泽明步的职业生涯达到巅峰。她不仅在日本国内积累了大量粉丝，在亚洲其他地区也拥有了广泛的知名度。这一时期的作品风格更加成熟多元，她展现出了极强的角色驾驭能力。2013年，她创下了个人年度作品发行量的最高纪录。</p>
    <h2>转型与多元化（2016-2019）</h2>
    <p>2016年后，吉泽明步开始有意识地进行事业转型。除了继续出演影视作品外，她还涉足了综艺节目、商业代言、品牌合作等多个领域。她参与的多个综艺节目获得了超高收视率，展现了她在荧幕之外的亲和力与幽默感。</p>
    <h2>现状与展望（2020至今）</h2>
    <p>进入2020年代，吉泽明步虽然减少了作品产出频率，但每一次亮相仍然引起广泛关注。她更多地转向幕后工作，参与制作和新人培养。同时，她通过社交媒体与粉丝保持紧密互动，展现出更加真实、自然的一面。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20film%20set%20scene%20with%20warm%20golden%20hour%20lighting%2C%20elegant%20atmosphere%2C%20professional%20camera%20equipment%20in%20background%2C%20soft%20focus%2C%20artistic%20cinematography%20style%2C%20refined%20and%20nostalgic%20mood&width=1200&height=675&seq=yoshizawa-career-01&orientation=landscape',
    date: '2026-07-20',
    readTime: '12 分钟',
    tags: ['演艺经历', '吉泽明步', '职业生涯', '回顾'],
    featured: true,
  },
  {
    id: '3',
    title: '吉泽明步十大经典作品推荐：粉丝必看指南',
    slug: 'yoshizawa-akihō-top-10-works',
    categoryId: 'works',
    categoryName: '代表作品',
    excerpt: '在吉泽明步丰富的作品库中，哪些是最值得一看的经典之作？本文为你精选十部最具代表性的作品，附带详细推荐理由。',
    content: `<p>在吉泽明步超过二十年的职业生涯中，她参演了数量庞大的影视作品。对于新粉丝来说，面对如此丰富的作品库可能会感到无从下手。本文精选了十部最具代表性的经典作品，帮助你快速了解她的艺术成就。</p>
    <h2>评选标准</h2>
    <p>本次评选综合考虑了作品的知名度、口碑评分、获奖情况以及粉丝推荐度等多个维度，力求为读者提供一份全面、客观的推荐指南。</p>
    <h2>十大经典作品</h2>
    <h3>1. 《初めての体験》- 2003年</h3>
    <p>作为吉泽明步的出道作品，这部作品具有重要的历史意义。虽然表演还略显青涩，但已经展现出她天生的镜头感和表现力。对于想要了解吉泽明步起点的粉丝来说，这是必看之作。</p>
    <h3>2. 《夏の思い出》- 2005年</h3>
    <p>这部夏日题材的作品展现了吉泽明步清新自然的一面。精美的画面质感和轻松的叙事风格，使其成为她早期作品中的一颗明珠。</p>
    <h3>3. 《都会の孤独》- 2007年</h3>
    <p>一部展现吉泽明步演技深度的代表作。她在片中诠释了一个复杂的都市女性角色，细腻的情感表达获得了评论界的一致好评。</p>
    <h3>4. 《愛の形》- 2009年</h3>
    <p>这部作品帮助吉泽明步获得了当年的最佳女演员奖。她在片中的表演被誉为"达到了新的艺术高度"。</p>
    <h3>5. 《夢の続き》- 2011年</h3>
    <p>一部充满艺术气息的作品，导演独特的视觉风格与吉泽明步的表演完美融合，创造出了令人难忘的观影体验。</p>
    <h3>6. 《秘密の花園》- 2012年</h3>
    <p>这部作品在粉丝中拥有极高的口碑，被誉为吉泽明步的"封神之作"。精彩的剧本加上出色的表演，使其成为不可错过的经典。</p>
    <h3>7. 《月光の下で》- 2014年</h3>
    <p>一部展现成熟魅力的代表作。吉泽明步在片中的造型和表演都达到了新的高度，展现出与早期作品截然不同的韵味。</p>
    <h3>8. 《永遠の約束》- 2016年</h3>
    <p>这部情感题材的作品展现了吉泽明步演技的细腻一面。她成功塑造了一个令人心碎又充满希望的角色。</p>
    <h3>9. 《旅立ちの日》- 2018年</h3>
    <p>一部公路题材的创新之作，展现了吉泽明步对不同类型角色的驾驭能力。影片的画面和音乐都极为出色。</p>
    <h3>10. 《新たなる章》- 2022年</h3>
    <p>吉泽明步近年来的重要作品，标志着她演艺生涯的新阶段。成熟、自信的表演风格令人印象深刻。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20movie%20poster%20collection%20display%20on%20warm%20lit%20wall%2C%20sophisticated%20gallery%20style%2C%20Japanese%20cinema%20aesthetic%2C%20soft%20ambient%20lighting%2C%20minimalist%20interior%20design%2C%20artistic%20curation%20atmosphere&width=1200&height=675&seq=yoshizawa-works-01&orientation=landscape',
    date: '2026-07-22',
    readTime: '15 分钟',
    tags: ['代表作品', '吉泽明步', '经典作品', '推荐'],
    featured: true,
  },
  {
    id: '4',
    title: '吉泽明步最新动态：2026年下半年活动预告',
    slug: 'yoshizawa-akihō-2026-latest-news',
    categoryId: 'news',
    categoryName: '最新动态',
    excerpt: '2026年下半年，吉泽明步将有多个公开活动与粉丝见面。本文汇总了目前已知的所有活动安排，方便粉丝提前规划参与。',
    content: `<p>2026年下半年，吉泽明步将继续活跃在公众视野中。根据目前已公布的信息，她将参与多个公开活动，为粉丝提供近距离接触的机会。</p>
    <h2>活动日程安排</h2>
    <h3>8月：粉丝见面会（东京站）</h3>
    <p>2026年8月20日，吉泽明步将在东京举办年度粉丝见面会。此次活动预计将有超过500名幸运粉丝获得入场资格。活动现场将包括互动问答、签名合影等环节。</p>
    <h3>9月：新作品发布会</h3>
    <p>9月中旬，吉泽明步将出席其最新作品的发布会。这部备受期待的作品经过近一年的精心制作，终于要与观众见面了。</p>
    <h3>10月：慈善公益活动</h3>
    <p>10月初，吉泽明步将参与一项关爱儿童的慈善公益活动。作为该活动的形象大使，她将亲自前往福利机构进行探访和捐赠。</p>
    <h3>11月：亚洲巡回粉丝见面会</h3>
    <p>11月，吉泽明步将启动亚洲巡回粉丝见面会，计划访问台北、香港、曼谷和首尔等城市。具体日期和场地信息将在后续公布。</p>
    <h3>12月：年度总结特别节目</h3>
    <p>12月底，吉泽明步将参与一档年度总结特别节目的录制，回顾2026年的精彩瞬间并展望2027年的计划。</p>
    <h2>社交媒体更新</h2>
    <p>吉泽明步近期在社交媒体上较为活跃，频繁分享日常生活和工作幕后花絮。建议粉丝关注她的官方账号以获取最新动态。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20event%20venue%20with%20warm%20stage%20lighting%2C%20elegant%20red%20carpet%20setting%2C%20sophisticated%20atmosphere%2C%20professional%20photography%2C%20grand%20but%20intimate%20feel&width=1200&height=675&seq=yoshizawa-news-01&orientation=landscape',
    date: '2026-08-01',
    readTime: '6 分钟',
    tags: ['最新动态', '吉泽明步', '活动预告', '2026'],
    featured: true,
  },
  {
    id: '5',
    title: '吉泽明步的身体数据与外形特征全面解析',
    slug: 'yoshizawa-akihō-physical-stats',
    categoryId: 'personal',
    categoryName: '个人资料',
    excerpt: '吉泽明步以其出众的外形条件在业内备受瞩目。本文详细解析她的身高、三围、体型等身体数据，以及她在形象管理方面的心得。',
    content: `<p>吉泽明步以其精致的五官和匀称的身材比例在业内独树一帜。多年来，她始终保持着良好的状态，这与她严格的自律和专业的形象管理密不可分。</p>
    <h2>详细身体数据</h2>
    <table>
    <tr><th>项目</th><th>数据</th></tr>
    <tr><td>身高</td><td>161 cm</td></tr>
    <tr><td>三围</td><td>B86 - W58 - H86 (cm)</td></tr>
    <tr><td>血型</td><td>A型</td></tr>
    <tr><td>星座</td><td>双鱼座</td></tr>
    <tr><td>鞋码</td><td>23.5 cm</td></tr>
    </table>
    <h2>外形特征</h2>
    <p>吉泽明步拥有一张精致的东方面孔，五官立体而不失柔和。她的眼睛尤其有神，被誉为"会说话的眼睛"。身高161cm的她虽然不算高挑，但身材比例极佳，腿部线条优美，整体给人以匀称、优雅的视觉感受。</p>
    <h2>形象管理心得</h2>
    <p>在多次访谈中，吉泽明步分享了她的形象管理秘诀。她强调均衡饮食和规律运动的重要性。据悉，她每周至少进行四次瑜伽和普拉提训练，同时严格控制糖分和高热量食物的摄入。此外，她也非常注重皮肤护理，每天坚持完整的护肤流程。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20wellness%20and%20fitness%20photography%20with%20warm%20natural%20light%2C%20yoga%20studio%20setting%2C%20minimalist%20interior%2C%20soft%20neutral%20colors%2C%20calm%20and%20serene%20atmosphere%2C%20professional%20lifestyle%20photography&width=1200&height=675&seq=yoshizawa-physical-01&orientation=landscape',
    date: '2026-07-18',
    readTime: '7 分钟',
    tags: ['个人资料', '吉泽明步', '身体数据', '形象管理'],
    featured: false,
  },
  {
    id: '6',
    title: '粉丝必知：吉泽明步官方社交媒体账号全指南',
    slug: 'yoshizawa-akihō-social-media-guide',
    categoryId: 'community',
    categoryName: '粉丝社区',
    excerpt: '想要第一时间获取吉泽明步的最新动态？本文整理了她在各大社交平台的官方账号信息，以及粉丝互动的最佳方式。',
    content: `<p>在社交媒体时代，关注偶像的官方账号是粉丝获取第一手资讯的最佳途径。吉泽明步活跃于多个主流社交平台，本文为你整理了她所有的官方认证账号。</p>
    <h2>主要社交平台</h2>
    <h3>Instagram</h3>
    <p>吉泽明步的Instagram账号是她最活跃的社交平台。她经常分享日常生活照片、工作幕后花絮以及旅行见闻。她的摄影风格清新自然，不刻意摆拍，展现出了真实可爱的一面。截至目前，她的Instagram粉丝数已突破百万。</p>
    <h3>Twitter（X）</h3>
    <p>在Twitter上，吉泽明步主要发布工作相关的信息和简短的日常感悟。她偶尔也会与粉丝进行互动问答，回复粉丝的评论。对于想要了解她最新工作动态的粉丝来说，Twitter是不可错过的信息源。</p>
    <h3>YouTube</h3>
    <p>吉泽明步的YouTube频道虽然更新频率不高，但每个视频都制作精良。内容包括Vlog、Q&A、美食探店等，展现了她多才多艺的一面。</p>
    <h3>官方粉丝俱乐部</h3>
    <p>对于深度粉丝来说，加入吉泽明步的官方粉丝俱乐部是最佳选择。会员可以享受独家内容、优先购票权和限量周边等福利。粉丝俱乐部定期举办线上线下的专属活动，为会员提供与偶像近距离互动的机会。</p>
    <h2>互动建议</h2>
    <p>在与吉泽明步互动时，建议粉丝保持礼貌和尊重。避免发送过于私人的问题或不当言论。真诚、温暖的留言更容易获得偶像的回应。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20social%20media%20interface%20with%20warm%20lighting%2C%20cozy%20cafe%20background%2C%20elegant%20lifestyle%20photography%2C%20soft%20bokeh%20effect%2C%20sophisticated%20and%20contemporary%20style&width=1200&height=675&seq=yoshizawa-social-01&orientation=landscape',
    date: '2026-07-25',
    readTime: '5 分钟',
    tags: ['粉丝社区', '吉泽明步', '社交媒体', '互动指南'],
    featured: false,
  },
  {
    id: '7',
    title: '吉泽明步获奖记录全收录：荣誉与成就的时间线',
    slug: 'yoshizawa-akihō-awards-history',
    categoryId: 'career',
    categoryName: '演艺经历',
    excerpt: '在超过二十年的职业生涯中，吉泽明步获得了众多行业奖项和荣誉。本文以时间线形式完整收录她的所有重要获奖记录。',
    content: `<p>在吉泽明步辉煌的职业生涯中，她凭借出色的表演获得了业内多项重要奖项的认可。这些荣誉不仅是对她演技的肯定，也是她职业生涯中一个个闪亮的里程碑。</p>
    <h2>获奖时间线</h2>
    <h3>2004年 - 最佳新人奖</h3>
    <p>出道仅一年，吉泽明步就凭借出色的表现获得了年度最佳新人奖，在业内引起了广泛关注。</p>
    <h3>2006年 - 最佳女配角奖</h3>
    <p>凭借在一部群像剧中的精彩表现，吉泽明步获得了最佳女配角奖，证明了她在不同类型角色中的适应能力。</p>
    <h3>2008年 - 最佳女演员奖</h3>
    <p>这是吉泽明步职业生涯中最重要的奖项之一。获得最佳女演员奖标志着她正式跻身行业顶级艺人的行列。</p>
    <h3>2010年 - 最受欢迎女艺人奖</h3>
    <p>由粉丝投票产生的最受欢迎女艺人奖，体现了吉泽明步在观众中超高的人气和号召力。</p>
    <h3>2013年 - 终身成就奖提名</h3>
    <p>尽管最终未能获奖，但获得终身成就奖的提名本身就是对她职业生涯的高度认可。</p>
    <h3>2015年 - 特别贡献奖</h3>
    <p>表彰吉泽明步多年来对行业发展的贡献。这个奖项不仅认可了她的艺术成就，也肯定了她在行业中的影响力。</p>
    <h3>2019年 - 跨界影响力奖</h3>
    <p>表彰吉泽明步在影视之外多领域发展的成就，包括综艺、商业代言等方面的卓越表现。</p>
    <h3>2023年 - 二十周年纪念荣誉</h3>
    <p>为纪念吉泽明步从业二十周年，业内特别颁发此荣誉，表彰她二十年来对行业的持续贡献。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20award%20trophy%20display%20with%20warm%20spotlight%20on%20dark%20background%2C%20prestigious%20ceremony%20setting%2C%20golden%20accents%2C%20sophisticated%20and%20glamorous%20atmosphere%2C%20professional%20photography&width=1200&height=675&seq=yoshizawa-awards-01&orientation=landscape',
    date: '2026-07-28',
    readTime: '10 分钟',
    tags: ['演艺经历', '吉泽明步', '获奖记录', '荣誉'],
    featured: true,
  },
  {
    id: '8',
    title: '吉泽明步粉丝应援指南：如何有组织地支持偶像',
    slug: 'yoshizawa-akihō-fan-support-guide',
    categoryId: 'community',
    categoryName: '粉丝社区',
    excerpt: '想要为吉泽明步应援但不知从何入手？本文为粉丝提供全面的应援指南，包括应援活动策划、礼物准备和现场注意事项。',
    content: `<p>粉丝应援是偶像文化中不可或缺的一部分。有组织、有温度的应援活动不仅能让偶像感受到支持，也能增强粉丝群体之间的凝聚力。以下是为吉泽明步应援的完整指南。</p>
    <h2>应援的基本原则</h2>
    <p>在进行应援活动时，需要遵循以下基本原则：尊重偶像的个人空间、遵守活动现场秩序、不进行任何可能给偶像带来困扰的行为。理性追星、文明应援是每一位粉丝应有的素养。</p>
    <h2>应援活动类型</h2>
    <h3>生日应援</h3>
    <p>吉泽明步的生日是3月3日。每年此时，粉丝后援会都会组织生日应援活动，包括制作生日祝福视频、准备生日礼物、在社交媒体上进行生日话题刷榜等。</p>
    <h3>作品发布应援</h3>
    <p>当吉泽明步有新作品发布时，粉丝可以通过购买正版作品、撰写优质评论、在社交媒体上宣传推广等方式进行应援。</p>
    <h3>活动现场应援</h3>
    <p>在粉丝见面会、发布会等活动现场，统一的应援色（金色）和应援口号能够营造出强大的视觉和听觉冲击力。</p>
    <h2>应援礼仪</h2>
    <p>送礼物时应选择有意义但不昂贵的物品，避免给偶像造成负担。手写信是最被推荐的礼物形式，因为它承载了粉丝最真挚的情感。在现场活动中，请遵守工作人员的指引，不要推搡拥挤，确保活动安全有序地进行。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20concert%20crowd%20with%20golden%20light%20sticks%20in%20dark%20venue%2C%20enthusiastic%20fan%20atmosphere%2C%20beautiful%20light%20patterns%2C%20emotional%20and%20energetic%20mood%2C%20professional%20event%20photography&width=1200&height=675&seq=yoshizawa-fansupport-01&orientation=landscape',
    date: '2026-08-05',
    readTime: '8 分钟',
    tags: ['粉丝社区', '吉泽明步', '应援指南', '粉丝活动'],
    featured: false,
  },
];